import { render, staticRenderFns } from "./TheCourseOutcomes.vue?vue&type=template&id=0f68d37f&scoped=true&"
import script from "./TheCourseOutcomes.vue?vue&type=script&lang=js&"
export * from "./TheCourseOutcomes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68d37f",
  null
  
)

export default component.exports